import React, { useState } from 'react';
import { useComunicacao } from '../../contexts/ComunicacaoContext';
import BarraFormatacao from '../common/BarraFormatacao';

interface FormComentarioProps {
  topicoId: string;
}

const FormComentario: React.FC<FormComentarioProps> = ({ topicoId }) => {
  const { criarComentario } = useComunicacao();
  const [mensagem, setMensagem] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!mensagem.trim()) {
      return;
    }

    try {
      setEnviando(true);
      await criarComentario({
        topicoId,
        mensagem: mensagem.trim()
      });
      setMensagem('');
    } catch (error) {
      console.error('Erro ao criar comentário:', error);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Adicionar comentário
        </label>
        <BarraFormatacao
          valor={mensagem}
          onChange={setMensagem}
          placeholder="Escreva seu comentário..."
          minHeight={96}
          disabled={enviando}
        />
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={!mensagem.trim() || enviando}
          className="px-4 py-2 bg-bravo-primary hover:bg-blue-600 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        >
          {enviando ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Enviando...
            </>
          ) : (
            'Enviar Comentário'
          )}
        </button>
      </div>
    </form>
  );
};

export default FormComentario;
